import script from "./goRinSyo0062.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0062.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0062.vue?vue&type=style&index=0&id=34a52340&lang=scss"

const __exports__ = script;

export default __exports__